export default __webpack_public_path__ + "static/media/dashboard.6514438d.svg";